(function($) {

  'use strict';

    // This code notifies Google Tag Manager when a wpForm is submitted
    document.addEventListener("DOMContentLoaded", function() {
      var elementsArray = document.querySelectorAll('[id^="wpforms-form-"]');
      elementsArray.forEach(function(elem) {
        elem.addEventListener("submit", function(e) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "wpFormSubmit",
            wpFormElement: event.target
          });
        });
      });
    });

  $(document).ready(function() {

      // There may be multiple 'nav' elements - change this to depend on your circumstances
      $('button.hamburger').on('click', function() {

          $('button.hamburger').toggleClass('is-active');
          $('body').toggleClass('show-mobile-menu');

      });

      $('.hero-video-link').on('click', function() {
        $('.hero-video-lightbox').addClass('active');
      });

      $('.hero-video-lightbox-close').on('click', function() {
        $('.hero-video-lightbox').removeClass('active');
      })

      $(document).keydown(function(event) {
        if(event.which == 27) $('.hero-video-lightbox').removeClass('active');
      });

      $('.trial_cta_button').on('touchstart touchend', function(e) {
        $(this).toggleClass('hover-effect');
      });

      $('.table-toggle').on('click', function() {
        var $button = $(this);
        var $table = $('#' + $button.attr('aria-controls'));
        var isExpanded = $button.attr('aria-expanded') === 'true';

        $button.attr('aria-expanded', !isExpanded);

        if (isExpanded) {
          $table.stop(true, true).slideUp(300, function() {
            $table.prop('hidden', true);
          });
        } else {
          $table.prop('hidden', false).hide().stop(true, true).slideDown(400);
        }
      });

      $('.ultra-stories-carousel').marmeloSlide({containerClass: '.ultra-stories-carousel-content', itemClass: '.slide', minNumber: 1})

      $('.modal-inner button').click(function(e) {
        $('.modal-wrapper').removeClass('active');
      });

      const scrollContainer = $('body.para-drop').length > 0 ? $('#wrapper') : $(window);
      // $('#wrapper').scroll( function() {
        scrollContainer.scroll( function() {
        //if($('#wrapper').scrollTop() > ($(window).height() / 4))
        if(scrollContainer.scrollTop() > ($(window).height() / 4))
          $('.floating-cta-wrapper').addClass('active');
        else 
          $('.floating-cta-wrapper').removeClass('active');
      })

  });

})(jQuery);